import React from 'react';
import img000 from '../components/images/sample.png';
import img2046 from '../components/images/ramazon.png';

const Events = () => {
    return (
        <>
            <div className="row m-2">
                <img className="img-fluid" src={img2046} alt="amazon" />
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h2>Why Amazon Registration is Essential</h2>
                        <p>
                            <strong>Amazon registration</strong> helps you reach millions of potential customers, enhances your brand credibility, and provides access to advanced logistics and marketing tools. To summarize, Amazon registration, be it as a seller, buyer, or business partner, will bring numerous benefits: streamlining e-commerce activities, increasing reach, and maximizing business growth. It provides a one-stop shop for sellers while creating a platform that ensures safety, convenience, and other special services for buyers.
                        </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6">
                        <h2>Essential Details Required:</h2>
                        <ul className="list-group">
                            <li className="list-group-item"><strong>Email ID:</strong> For account setup and communication.</li>
                            <li className="list-group-item"><strong>Contact Number:</strong> Needed for verification and customer interaction.</li>
                            <li className="list-group-item"><strong>GST Certificate:</strong> Validates your business and ensures tax compliance.</li>
                            <li className="list-group-item"><strong>Pickup Address:</strong> For product pickups and order fulfillment.</li>
                            <li className="list-group-item"><strong>Bank Details:</strong> To receive payments securely.</li>
                            <li className="list-group-item"><strong>Product Category:</strong> Helps Amazon categorize your products for better visibility.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <p className="mt-4">
                    <strong>Get started now</strong> and expand your business on a trusted platform. Contact us at E Seller Support for assistance.
                </p>
            </div>
        </>
    );
};

export default Events;
